export const SET_SELECTED_TAB = 'GOAL.SET_SELECTED_TAB';
export const RESET_STATE = 'GOAL.RESET_STATE';

export const setSelectedTab = (payload: { tab: any }) => {
  return {
    type: SET_SELECTED_TAB,
    payload,
  };
};

export const resetState = () => ({
  type: RESET_STATE,
});
